import * as palate from './palate';
import * as user from './userServices';

export default {...palate, ...user};
